import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import ColumnChart from "../charts/generic/ColumnChart"
import { CHARTS } from "../../constants"
import RiskOfLeavingBarShape from "../../state/shapes/RiskOfLeavingBarShape"

function RiskOfLeavingBar({ appliedFilters, exportEndpoint, data, subtitleKey }) {
  const barChartData = {
    categories: [],
    bars: [
      {
        name: "Widgets.RiskOfLeaving.Low",
        data: []
      },
      {
        name: "Widgets.RiskOfLeaving.Medium",
        data: []
      },
      {
        name: "Widgets.RiskOfLeaving.High",
        data: []
      }
    ]
  }

  data.forEach(d => {
    // Each review name will be a set of results
    barChartData.categories.push(d.reviewName)
    // Results need to be added to same index as category Looping after creation
    // would keep same index
    barChartData.bars.forEach(b => {
      if (b.name === "Widgets.RiskOfLeaving.Low") b.data.push(d.lowCount)
      else if (b.name === "Widgets.RiskOfLeaving.Medium") b.data.push(d.mediumCount)
      else if (b.name === "Widgets.RiskOfLeaving.High") b.data.push(d.highCount)
    })
  })

  // Sort the bars after creation and population, we want to ensure any bars with 0 data
  // are not shown in the filter.. therefore we flag them for splicing.
  barChartData.bars.forEach((b, index) => {
    b.anyData = false

    // Loop over each data element for the bar
    b.data.forEach(d => {
      // If there is no data and it's above 0 set the flag
      if (!b.anyData && d > 0) {
        b.anyData = true
      }
    })
  })

  const barColours = [
    CHARTS.trafficLightColours.green,
    CHARTS.trafficLightColours.amber,
    CHARTS.trafficLightColours.red
  ]

  // Once the ones for splicing have been identified we can then loop backwards and remove them.
  for (let i = barChartData.bars.length - 1; i > -1; i--) {
    // eslint-disable-line no-plusplus
    // If there is no data (above 0) for a bar then we will splice it
    if (!barChartData.bars[i].anyData) {
      barChartData.bars.splice(i, 1)

      // Also remove the relevant colour
      barColours.splice(i, 1)
    }
  }

  const titleKey="Widgets.RiskOfLeavingBar.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.RiskOfLeavingBar.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
    >
      <ColumnChart
        data={barChartData}
        yAxisTitle="Common.People"
        chartType="column"
        overrideColours={barColours}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
    </Widget>
  )
}

RiskOfLeavingBar.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(RiskOfLeavingBarShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string
}

export default RiskOfLeavingBar



// WEBPACK FOOTER //
// ./src/components/widgets/RiskOfLeavingBar.jsx